import React from "react";
import { Snackbar } from "@material-ui/core";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";
import { Alert } from "~/types/component";

const AlertComponent: React.VFC<AlertProps> = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

type SnackbarAlertProps = {
  open: boolean;
  onClose: () => void;
  message?: Alert["message"];
  type?: Alert["type"];
};
export const SnackbarAlert: React.VFC<SnackbarAlertProps> = (props) => {
  return (
    <Snackbar
      open={props.open}
      autoHideDuration={5000}
      onClose={props.onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <AlertComponent severity={props.type ?? "error"}>
        {props.message ?? ""}
      </AlertComponent>
    </Snackbar>
  );
};
